import { getUserSnippetPipeline } from "../users";
import { profileCategoryPipeline } from "./profile-pipelines";
import { zPublicProfile } from "./public-profile-resource";

export function getPublicProfilePipelines() {
  const publicProfileUserPipeline = getUserSnippetPipeline("userId", "userDoc");

  return {
    _z: zPublicProfile,
    mainStages: [...publicProfileUserPipeline.mainStages, ...profileCategoryPipeline.mainStages],
    projectStage: {
      // common
      "profileType": 1,
      "_id": 1,
      "selectedProfileTemplate": 1,
      "primaryLocation.city": 1,
      "primaryLocation.country": 1,
      "languages": 1,

      // companies-common
      "companyInfo": 1,
      "companyOverview": 1,

      // provider-common
      "experienceLevel": 1,
      "linkedAccounts": 1,

      // provider-professional
      "title": 1,
      "overview": 1,
      "workHistory": 1,
      "educationHistory": 1,

      // provider-business
      "trustedBy": 1,
      "qualifications": 1,

      ...publicProfileUserPipeline.projectStage,
      ...profileCategoryPipeline.projectStage,
    },
  };
}
